import { useContext } from 'react';
import { EditInapectionContaxt } from './editInspectionProviderImports';
import { Grid, Hidden, Paper, TableBody, TableContainer, TableHead, TableRow, Typography, Table, FormHelperText, colors } from '@material-ui/core';
import { CustomChip, UploadWithBadge } from '../../../../../../Core/Controls';
import EditIcon from '@material-ui/icons/Edit';
import { CheckFieldType } from '../CheckFieldType';
import { useHistory } from 'react-router-dom';

export const EditInspection = ({ classes, StyledTableCell, StyledTableRow, CheckButtons }) => {
    const history = useHistory();
    const { state, imageHandler, actionTakenHandle, flags, handleInpectionRow } = useContext(EditInapectionContaxt);

    const handleClick = (defID) => {
        const url = `${window.location.origin}/maintenance/defect/edit/${defID}/${state.vehicleID}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    console.log('state', state.vehicleDailyChecks);
    return (
        <>
            {state.vehicleDailyChecks.map((m, i) => (
                <Grid item xs={12} md={12} lg={12} key={i} id="pageStart">
                    <TableContainer component={Paper}>
                        <div
                            style={{
                                border: '1px solid rgba(0,0,0,0.2)'
                            }}
                        >
                            <h3 className={classes.title}>{m.name}</h3>
                        </div>
                        <Table aria-label="simple table" className={classes.paper}>
                            <TableHead>
                                <Hidden only={['md', 'sm', 'xs']}>
                                    <TableRow>
                                        <StyledTableCell width="45%">Check</StyledTableCell>

                                        {flags.displayCustomerDeclaration === 2 && (
                                            <StyledTableCell
                                                width="10%"
                                                onClick={() => handleInpectionRow(m[0].startVehicleInspectionID)}
                                                style={{ cursor: 'pointer' }}
                                                // startVehicleInspectionID
                                            >
                                                {flags.startEventLabel}
                                            </StyledTableCell>
                                        )}
                                        <StyledTableCell align="center" width="10%">
                                            {flags.displayCustomerDeclaration === 1
                                                ? flags.startEventLabel
                                                : flags.displayCustomerDeclaration === 2
                                                  ? flags.endEventLabel
                                                  : 'Result'}
                                        </StyledTableCell>
                                        <StyledTableCell align="center" width="5%">
                                            Upload
                                        </StyledTableCell>
                                        <StyledTableCell align="left" width={flags.displayStartEvent ? '30%' : '40%'}>
                                            Defect Found
                                        </StyledTableCell>
                                    </TableRow>
                                </Hidden>
                                <Hidden only={['lg', 'xl']}>
                                    <TableRow>
                                        <StyledTableCell width="50%">Check</StyledTableCell>
                                    </TableRow>
                                </Hidden>
                            </TableHead>
                            <TableBody>
                                {m.map((p, i) => (
                                    <>
                                        <Hidden only={['md', 'sm', 'xs']}>
                                            <StyledTableRow
                                                style={{
                                                    backgroundColor:
                                                        p.inspectionSheetCheckResultOptionCode == 'D'
                                                            ? '#f58a88'
                                                            : p.inspectionSheetCheckResultOptionCode == 'M'
                                                              ? '#FFD65C'
                                                              : ''
                                                }}
                                            >
                                                <StyledTableCell component="th">
                                                    {' '}
                                                    <div style={{ fontWeight: 600, color: 'black' }}>{p.inspectionSheetCheckDescription}</div>
                                                    {p.inspectionSheetCheckInformation && (
                                                        <div style={{ fontWeight: 400, color: 'black', fontSize: 11, textAlign: 'justify' }}>
                                                            {p.inspectionSheetCheckInformation}
                                                        </div>
                                                    )}
                                                </StyledTableCell>
                                                {/* //onhIRE  */}
                                                {flags.displayCustomerDeclaration === 2 && (
                                                    <>
                                                        {!p.startFreeText ? (
                                                            <StyledTableCell align="center">
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        // background: 'yellow',
                                                                        justifyContent: 'center',
                                                                        gap: 10
                                                                    }}
                                                                >
                                                                    {p.startResultCode ? (
                                                                        state.buttonList.map((b) => {
                                                                            const Comp = CheckButtons[b.inspectionSheetCheckOptionCode] || ' Button';
                                                                            const checks = p.startResultCode;

                                                                            if (checks === b.inspectionSheetCheckOptionCode) {
                                                                                return (
                                                                                    // <StyledTableCell align="center">
                                                                                    <Comp
                                                                                        state={p.startResultCode === b.inspectionSheetCheckOptionCode}
                                                                                        disabled={true}
                                                                                    ></Comp>
                                                                                    // </StyledTableCell>
                                                                                );
                                                                            }
                                                                        })
                                                                    ) : (
                                                                        <div
                                                                            style={{
                                                                                width: 35
                                                                            }}
                                                                        ></div>
                                                                    )}

                                                                    <UploadWithBadge
                                                                        onClick={() =>
                                                                            imageHandler(p.startInspectionSheetCheckResultID, p.inspectionSheetCheckResultID)
                                                                        }
                                                                        count={p.startPhotosUploaded || p.basicCount}
                                                                        state={p.startPhotosUploaded > 0 || p.basicCount > 0}
                                                                    />
                                                                </div>
                                                            </StyledTableCell>
                                                        ) : (
                                                            <StyledTableCell align="center">
                                                                <FormHelperText
                                                                    shrink
                                                                    style={{
                                                                        fontWeight: 500,
                                                                        color: 'black',
                                                                        // background: 'red',
                                                                        lineHeight: 1,
                                                                        fontSize: 14,
                                                                        textAlign: 'center'
                                                                    }}
                                                                >
                                                                    {p.startFreeText}
                                                                </FormHelperText>
                                                            </StyledTableCell>
                                                        )}
                                                    </>
                                                )}

                                                <StyledTableCell align="center">
                                                    <CheckFieldType
                                                        fieldTypeId={p.inspectionSheetCheckFieldTypeID}
                                                        name="inspectionSheetCheckResultNotes"
                                                        value={p.inspectionSheetCheckResultEnteredText}
                                                        onChange={() => {}}
                                                        btnList={state.buttonList}
                                                        CheckButtons={CheckButtons}
                                                        changeState={() => {}}
                                                        p={p}
                                                        listType={p.inspectionSheetCheckListTypeID}
                                                        disabled={true}
                                                        listOptionsVM={state.listOptionsVM}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {!p.inspectionSheetCheckCanHidePhotoUpload ? (
                                                        <UploadWithBadge
                                                            onClick={() => imageHandler(p.inspectionSheetCheckResultID)}
                                                            count={p.photosUploaded || p.basicCount}
                                                            state={p.photosUploaded > 0 || p.basicCount > 0}
                                                        />
                                                    ) : (
                                                        '-'
                                                    )}
                                                </StyledTableCell>

                                                <StyledTableCell align="center">
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justify: 'space-between',
                                                            alignItems: 'center',
                                                            gap: '8px',
                                                            cursor: p.inspectionSheetCheckResultDefectID ? 'pointer' : 'default'
                                                        }}
                                                        onClick={
                                                            p.inspectionSheetCheckResultDefectID
                                                                ? () => handleClick(p.inspectionSheetCheckResultDefectID)
                                                                : () => {}
                                                        }
                                                    >
                                                        {!p.inspectionSheetCheckCanHideDefectDescription ? (
                                                            <>
                                                                <div>
                                                                    <div
                                                                        style={{
                                                                            fontWeight: 600,
                                                                            color: 'black',
                                                                            textDecoration: p.inspectionSheetCheckResultDefectID ? 'underline' : ''
                                                                        }}
                                                                    >
                                                                        {p.inspectionSheetCheckResultNotes ? p.inspectionSheetCheckResultNotes : 'N/A'}{' '}
                                                                    </div>
                                                                </div>
                                                                {p.defectStatusID && (
                                                                    <div>
                                                                        <CustomChip
                                                                            icon={EditIcon}
                                                                            iconFontSize={16}
                                                                            label={p.defectStatusID !== 1 ? `${p.resultStatus} by ${p.rectifiedBy}` : 'Action'}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                actionTakenHandle(p);
                                                                            }}
                                                                            className="btn-m"
                                                                            style={{
                                                                                fontWeight: 'bold',
                                                                                backgroundColor:
                                                                                    p.defectStatusID && p.rectifiedBy ? `${p.backgroundColour}` : ''
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </>
                                                        ) : (
                                                            '-'
                                                        )}
                                                    </div>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        </Hidden>
                                        <Hidden only={['lg', 'xl']}>
                                            <StyledTableRow
                                                style={{
                                                    backgroundColor:
                                                        p.inspectionSheetCheckResultOptionCode == 'D'
                                                            ? '#f58a88'
                                                            : p.inspectionSheetCheckResultOptionCode == 'M'
                                                              ? '#FFD65C'
                                                              : ''
                                                }}
                                            >
                                                <StyledTableCell component="th">
                                                    <Grid container direction="column" spacing={1}>
                                                        <Grid item>
                                                            <Grid container spacing={2} alignItems="center" justify="space-between">
                                                                {/* Description */}
                                                                <Grid item xs={12} md>
                                                                    <Typography style={{ fontWeight: 600, color: '#000' }}>
                                                                        {p.inspectionSheetCheckDescription}
                                                                    </Typography>
                                                                </Grid>

                                                                {/* Information */}
                                                                {p.inspectionSheetCheckInformation && (
                                                                    <Grid item xs={12} md>
                                                                        <Typography
                                                                            style={{
                                                                                fontWeight: 400,
                                                                                color: '#000',
                                                                                fontSize: 11,
                                                                                textAlign: 'justify'
                                                                            }}
                                                                        >
                                                                            {p.inspectionSheetCheckInformation}
                                                                        </Typography>
                                                                    </Grid>
                                                                )}

                                                                {/* Field Component */}
                                                                <Grid item xs={12} md="auto">
                                                                    <CheckFieldType
                                                                        fieldTypeId={p.inspectionSheetCheckFieldTypeID}
                                                                        name="inspectionSheetCheckResultNotes"
                                                                        value={p.inspectionSheetCheckResultEnteredText}
                                                                        onChange={() => {}}
                                                                        btnList={state.buttonList}
                                                                        CheckButtons={CheckButtons}
                                                                        changeState={() => {}}
                                                                        p={p}
                                                                        listType={p.inspectionSheetCheckListTypeID}
                                                                        disabled={true}
                                                                        listOptionsVM={state.listOptionsVM}
                                                                        photoUploadComponent={
                                                                            !p.inspectionSheetCheckCanHidePhotoUpload && (
                                                                                <UploadWithBadge
                                                                                    onClick={() => imageHandler(p.inspectionSheetCheckResultID)}
                                                                                    count={p.photosUploaded || p.basicCount}
                                                                                    state={p.photosUploaded > 0 || p.basicCount > 0}
                                                                                />
                                                                            )
                                                                        }
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>

                                                        {/* Defect Description */}
                                                        {!p.inspectionSheetCheckCanHideDefectDescription && (
                                                            <Grid item xs={12}>
                                                                <Typography
                                                                    variant="caption"
                                                                    display="block"
                                                                    gutterBottom
                                                                    onClick={
                                                                        p.inspectionSheetCheckResultDefectID
                                                                            ? () => handleClick(p.inspectionSheetCheckResultDefectID)
                                                                            : () => {}
                                                                    }
                                                                    style={{
                                                                        cursor: p.inspectionSheetCheckResultDefectID ? 'pointer' : 'default',
                                                                        textDecoration: p.inspectionSheetCheckResultDefectID ? 'underline' : 'none'
                                                                    }}
                                                                >
                                                                    Defect Found: {p.inspectionSheetCheckResultNotes || 'N/A'}{' '}
                                                                    {p.defectStatusID && (
                                                                        <CustomChip
                                                                            icon={EditIcon}
                                                                            iconFontSize={16}
                                                                            label={p.defectStatusID !== 1 ? `${p.resultStatus} by ${p.rectifiedBy}` : 'Action'}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                actionTakenHandle(p);
                                                                            }}
                                                                            className="btn-m"
                                                                            style={{
                                                                                fontWeight: 'bold',
                                                                                backgroundColor:
                                                                                    p.defectStatusID && p.rectifiedBy ? `${p.backgroundColour}` : ''
                                                                            }}
                                                                        />
                                                                    )}
                                                                </Typography>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        </Hidden>
                                    </>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            ))}
        </>
    );
};
